import { render } from "./admissionView.vue?vue&type=template&id=78f28189"
import script from "./admissionView.vue?vue&type=script&lang=js"
export * from "./admissionView.vue?vue&type=script&lang=js"

import "./admissionView.vue?vue&type=style&index=0&id=78f28189&lang=css"

import exportComponent from "E:\\edu-ui\\JzEducationAdmin\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__